import { BASE_CONTEXT_V2_ADMIN } from "../api-context";

export const SURVEY_CONFIGURATION = {
  LIST: `${BASE_CONTEXT_V2_ADMIN}survey_configuration/list`,
  CREATE: `${BASE_CONTEXT_V2_ADMIN}survey_configuration/create`,
  UPDATE: `${BASE_CONTEXT_V2_ADMIN}survey_configuration/update`,
  DELETE: (survey_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey_configuration/delete/${survey_id}`,
};

export const SURVEY_PARTICIPATION = {
  POPUP_STATUS: (wwid: number) => `${BASE_CONTEXT_V2_ADMIN}survey_participation/popup_status/${wwid}`,
  SURVEY_LINK: `${BASE_CONTEXT_V2_ADMIN}survey_participation/survey_link`,
  MARK_PARTICIPATED: (wwid: number, survey_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey_participation/mark_participated/${wwid}/${survey_id}`,
  REMIND_LATER: (wwid: number, survey_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey_participation/remind_later/${wwid}/${survey_id}`,
  REMIND_TOMORROW: (wwid: number, survey_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey_participation/remind_tomorrow/${wwid}/${survey_id}`,
  OPT_OUT: (wwid: number, survey_id: number) => `${BASE_CONTEXT_V2_ADMIN}survey_participation/opt_out/${wwid}/${survey_id}`,
};
